import { render, staticRenderFns } from "./menu-view.vue?vue&type=template&id=09e463f9&"
import script from "./menu-view.vue?vue&type=script&lang=js&"
export * from "./menu-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports